module.exports = __webpack_public_path__ + "static/media/07-jose-emmanuel.2d01fe99.webp";